export default "__VITE_ASSET__BPjwVIHz__"